import { ClientInteractions, InteractionOutcomes } from 'types'
import { ClientStatus } from 'storeTypes'
import {
    EnrollIcon,
    NotInterestedIcon,
    FollowUpIcon,
    InteractionMobileMoneyPaymentIcon
} from 'assets'
import { colors } from 'styles/colors'

enum SectionNames {
    PACKAGES = 'packages',
    PAY = 'pay',
    OTHERS = 'others'
}

export type InteractionButton = {
    name: ClientInteractions
    icon: () => JSX.Element
    outcome: InteractionOutcomes
    section: SectionNames
    displayLabel: boolean
}

const enrollmentInteraction = {
    name: ClientInteractions.ENROLL,
    icon: EnrollIcon,
    outcome: InteractionOutcomes.ENROLLED,
    section: SectionNames.PACKAGES,
    displayLabel: false
}

const mobileMoneyPaymentInteraction = {
    name: ClientInteractions.MOBILE_MONEY_PAYMENT,
    icon: InteractionMobileMoneyPaymentIcon,
    outcome: InteractionOutcomes.MOBILE_MONEY_PAYMENT,
    section: SectionNames.PAY,
    displayLabel: false
}

const requestFollowUpInteraction = {
    name: ClientInteractions.REQUEST_FOLLOW_UP,
    icon: FollowUpIcon,
    outcome: InteractionOutcomes.FOLLOW_UP,
    section: SectionNames.OTHERS,
    displayLabel: true
}

const notInterestedInteraction = {
    name: ClientInteractions.NOT_INTERESTED,
    icon: NotInterestedIcon,
    outcome: InteractionOutcomes.NOT_INTERESTED,
    section: SectionNames.OTHERS,
    displayLabel: true
}

const CLIENT_STATUSES_TO_INTERACTIONS = {
    [ClientStatus.ENROLLED]: [
        mobileMoneyPaymentInteraction,
        requestFollowUpInteraction
    ],
    [ClientStatus.PACKAGE_WITHOUT_PAYMENT]: [
        {
            ...mobileMoneyPaymentInteraction,
            outcome: InteractionOutcomes.ENROLLED
        },
        requestFollowUpInteraction
    ],
    [ClientStatus.PAYMENT_WITHOUT_PACKAGE]: [
        enrollmentInteraction,
        requestFollowUpInteraction,
        notInterestedInteraction
    ],
    [ClientStatus.POTENTIAL]: [
        enrollmentInteraction,
        requestFollowUpInteraction,
        notInterestedInteraction
    ],
    [ClientStatus.FINISHED]: [
        requestFollowUpInteraction,
        notInterestedInteraction
    ],
    [ClientStatus.DUPLICATE]: []
}

export const getInteractionsFromClientStatus = (clientStatus: ClientStatus) => {
    return CLIENT_STATUSES_TO_INTERACTIONS[clientStatus] || []
}

export const interactionOutcomeStyles = {
    [InteractionOutcomes.FOLLOW_UP]: {
        color: colors.primary,
        btnStyle: 'info',
        className: 'follow_up'
    },
    [InteractionOutcomes.NOT_INTERESTED]: {
        color: colors.primary,
        btnStyle: 'light',
        className: 'not_interested'
    },
    [InteractionOutcomes.DUPLICATE]: {
        color: colors.darkGrey,
        btnStyle: 'light',
        className: 'duplicate'
    },
    default: {
        color: colors.maroon,
        btnStyle: 'warning',
        className: 'default'
    }
}
